import b from 'b_';
import cx from 'classnames';
import React, { useCallback } from 'react';

import { SimpleCallback } from '../../../typings';
import { PAGINATOR_BUTTON_VIEW } from '../paginator.constants';
import { Page } from '../types';

import './paginator__button.scss';

export interface PaginatorButtonProps {
    'aria-label'?: string;
    mix?: string;
    onClick?: (number: Page['number']) => void;
    clickable: boolean;
    selected?: boolean;
    view?: PAGINATOR_BUTTON_VIEW;
    onMouseEnter?: SimpleCallback;
    onMouseOut?: SimpleCallback;
    number: Page['number'];
}

const PaginatorButton = React.forwardRef<HTMLButtonElement, React.PropsWithChildren<PaginatorButtonProps>>(
    (props, ref) => {
        const {
            'aria-label': ariaLabel,
            mix,
            children,
            onClick,
            onMouseEnter,
            onMouseOut,
            clickable,
            selected,
            view,
            number,
        } = props;

        const clickHandler = useCallback(() => {
            if (onClick) {
                onClick(number);
            }
        }, [number, onClick]);

        return (
            <button
                aria-label={ariaLabel}
                aria-selected={selected}
                className={cx(b('paginator', 'button', { clickable, selected: selected, view }), mix)}
                onClick={clickHandler}
                onMouseEnter={onMouseEnter}
                onMouseOut={onMouseOut}
                ref={ref}
            >
                <div className={b('paginator', 'button-background', { selected, view })} />
                <div className={b('paginator', 'button-content')}>{children}</div>
            </button>
        );
    }
);

export default PaginatorButton;
